import { Cirus } from "@/classes/Http";
import { AxiosResponse } from "axios";
import { IsNumber, Max, Min, validate } from "class-validator";
import { Message } from "element-ui";

class Body {
    constructor(body: Body) {
        this.Amount = body.Amount;
    }

    @IsNumber()
    @Min(10000)
    @Max(20000000)
    Amount!: number;
}

class Response {
    err?: string;
    payment_url?: string;
}

export async function depositUserMoney(params: Body): Promise<AxiosResponse<Response>>{
    params = new Body(params);    
    const errors = await validate(params);
    if (errors.length>0)  {
        Message.error('لطفا مبلغ را بین ۱۰۰ هزار تومان تا ۲۰ میلیون تومان وارد کنید.')
        throw new Error("اطلاعات وارد شده صحیح نمی ‌باشد.");
    }
    const path = `/user/deposit/`;
    return Cirus.put(path, params);
}